import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { FaGraduationCap } from "react-icons/fa";

// Inline SVG Icons
const LinkedInIcon = () => (
  <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 448 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
    <path d="M416 32H31.9C14.3 32 0 46.5 0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6 0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3 0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2 0 38.5 17.3 38.5 38.5 0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9V416z"></path>
  </svg>
);

const GithubIcon = () => (
  <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 496 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
    <path d="M165.9 397.4c0 2-2.3 3.6-5.2 3.6-3.3.3-5.6-1.3-5.6-3.6 0-2 2.3-3.6 5.2-3.6 3-.3 5.6 1.3 5.6 3.6zm-31.1-4.5c-.7 2 1.3 4.3 4.3 4.9 2.6 1 5.6 0 6.2-2s-1.3-4.3-4.3-5.2c-2.6-.7-5.5.3-6.2 2.3zm44.2-1.7c-2.9.7-4.9 2.6-4.6 4.9.3 2 2.9 3.3 5.9 2.6 2.9-.7 4.9-2.6 4.6-4.6-.3-1.9-3-3.2-5.9-2.9zM244.8 8C106.1 8 0 113.3 0 252c0 110.9 69.8 205.8 169.5 239.2 12.8 2.3 17.3-5.6 17.3-12.1 0-6.2-.3-40.4-.3-61.4 0 0-70 15-84.7-29.8 0 0-11.4-29.1-27.8-36.6 0 0-22.9-15.7 1.6-15.4 0 0 24.9 2 38.6 25.8 21.9 38.6 58.6 27.5 72.9 20.9 2.3-16 8.8-27.1 16-33.7-55.9-6.2-112.3-14.3-112.3-110.5 0-24.4 8.6-44.5 23.6-61.4-2.6-6.5-11.1-33.3 2.6-67.9 20.9-6.5 69 27 69 27 20-5.6 41.5-8.5 62.8-8.5s42.8 2.9 62.8 8.5c0 0 48.1-33.6 69-27 13.7 34.7 5.2 61.4 2.6 67.9 16 17.7 25.8 37 25.8 61.4 0 96.5-58.9 104.2-114.8 110.5 9.2 7.9 17 22.9 17 46.4 0 33.7-.3 75.4-.3 83.6 0 6.5 4.6 14.4 17.3 12.1C428.2 457.8 496 362.9 496 252 496 113.3 383.5 8 244.8 8zM97.2 352.9c-1.3 1-1 3.3.7 5.2 1.6 1.6 3.9 2.3 5.2 1 1.3-1 1-3.3-.7-5.2-1.6-1.6-3.9-2.3-5.2-1zm-10.8-8.1c-.7 1.3.3 2.9 2.3 3.9 1.6 1 3.6.7 4.3-.7.7-1.3-.3-2.9-2.3-3.9-2-.6-3.6-.3-4.3.7zm32.4 35.6c-1.6 1.3-1 4.3 1.3 6.2 2.3 2.3 5.2 2.6 6.5 1 1.3-1.3.7-4.3-1.3-6.2-2.2-2.3-5.2-2.6-6.5-1zm-11.4-14.7c-1.6 1-1.6 3.6 0 5.9 1.6 2.3 4.3 3.3 5.6 2.3 1.6-1.3 1.6-3.9 0-6.2-1.4-2.3-4-3.3-5.6-2z"></path>
  </svg>
);

const EnvelopeIcon = () => (
  <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 512 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
    <path d="M502.3 190.8c3.9-3.1 9.7-.2 9.7 4.7V400c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V195.6c0-5 5.7-7.8 9.7-4.7 22.4 17.4 52.1 39.5 154.1 113.6 21.1 15.4 56.7 47.8 92.2 47.6 35.7.3 72-32.8 92.3-47.6 102-74.1 131.6-96.3 154-113.7zM256 320c23.2.4 56.6-29.2 73.4-41.4 132.7-96.3 142.8-104.7 173.4-128.7 5.8-4.5 9.2-11.5 9.2-18.9v-19c0-26.5-21.5-48-48-48H48C21.5 64 0 85.5 0 112v19c0 7.4 3.4 14.3 9.2 18.9 30.6 23.9 40.7 32.4 173.4 128.7 16.8 12.2 50.2 41.8 73.4 41.4z"></path>
  </svg>
);

const QUICK_LINKS = [
  { label: "Courses", to: "/courses" },
  { label: "Services", to: "/services" },
  { label: "Projects", to: "/projects" },
  { label: "Internship", to: "/internship" },
  { label: "PYQ Papers", to: "/pyq" },
  { label: "Resources", to: "/resources" },
  { label: "Blog", to: "/blog" },
];

const COMPANY_LINKS = [
  { label: "About Us", to: "/about" },
  { label: "Help Center", to: "/help" },
  { label: "Contact Us", to: "/contact" },
  { label: "Verify a Certificate", to: "/certificate/verify" },
  { label: "Privacy Policy", to: "/privacy" },
  { label: "Terms & Conditions", to: "/terms" },
];

function Footer() {
  useEffect(() => {
    const styleId = "bytegurukul-footer-styles";
    if (!document.getElementById(styleId)) {
      const styleSheet = document.createElement("style");
      styleSheet.id = styleId;
      styleSheet.innerText = hoverStyles;
      document.head.appendChild(styleSheet);
    }
  }, []);

  const year = new Date().getFullYear();

  return (
    <footer style={styles.footer} className="bytegurukul-footer">
      <div style={styles.accent} aria-hidden="true" />
      <div style={styles.container} className="footer-container">
        {/* Brand Section */}
        <div style={styles.brandSection} className="brand-section">
          <div style={styles.brandRow}>
            <span style={styles.brandMark} aria-hidden="true"><FaGraduationCap /></span>
            <span style={styles.brand} className="footer-brand">ByteGurukul</span>
          </div>
          <p style={styles.desc} className="footer-desc">
            Accessible courses, projects, internships and previous year papers for AKTU and every computer science &amp; IT student — in one place.
          </p>
          <div style={styles.contactBlock}>
            <a href="mailto:contact@bytegurukul.tech" style={styles.contactLine} className="footer-link">contact@bytegurukul.tech</a>
            <a href="tel:+916386569211" style={styles.contactLine} className="footer-link">+91 63865 69211</a>
          </div>
          <div style={styles.socialIcons} className="social-icons">
            <a href="https://linkedin.com/in/abhitech07" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" style={styles.iconLink} className="footer-icon"><LinkedInIcon /></a>
            <a href="https://github.com/abhitech07" target="_blank" rel="noopener noreferrer" aria-label="GitHub" style={styles.iconLink} className="footer-icon"><GithubIcon /></a>
            <a href="mailto:contact@bytegurukul.tech" aria-label="Email" style={styles.iconLink} className="footer-icon"><EnvelopeIcon /></a>
          </div>
        </div>

        {/* Links */}
        <div className="links-wrapper" style={styles.linksWrapper}>
          <div style={styles.linkSection} className="link-section">
            <h4 style={styles.heading} className="footer-heading">Explore</h4>
            {QUICK_LINKS.map((link) => (
              <Link key={link.label} to={link.to} style={styles.link} className="footer-link">{link.label}</Link>
            ))}
          </div>

          <div style={styles.linkSection} className="link-section">
            <h4 style={styles.heading} className="footer-heading">Company &amp; support</h4>
            {COMPANY_LINKS.map((link) => (
              <Link key={link.label} to={link.to} style={styles.link} className="footer-link">{link.label}</Link>
            ))}
          </div>
        </div>
      </div>

      <div style={styles.bottomBar} className="bottom-bar">
        <p style={styles.copyText} className="copy-text">
          © {year} <strong>ByteGurukul</strong> — All rights reserved.
        </p>
        <p style={styles.credit} className="copy-text">
          Designed &amp; built with <span style={{ color: "#f472b6" }}>♥</span> by Abhijeet Kumar Pandey
        </p>
      </div>
    </footer>
  );
}

const styles = {
  footer: {
    position: "relative",
    background: "linear-gradient(135deg, #312e81 0%, #4338ca 55%, #6d28d9 100%)",
    color: "white",
    padding: "40px 20px 16px",
    fontFamily: "var(--font-sans, 'Poppins', sans-serif)",
    width: "100%",
    boxSizing: "border-box",
    overflow: "hidden",
  },
  accent: {
    position: "absolute", top: 0, left: 0, right: 0, height: 4,
    background: "linear-gradient(90deg, #60a5fa, #a78bfa, #f472b6)",
  },
  container: {
    maxWidth: "1200px",
    margin: "0 auto",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    alignItems: "flex-start",
    gap: "32px",
  },
  brandSection: { flex: "1 1 320px", display: "flex", flexDirection: "column", gap: "12px" },
  brandRow: { display: "flex", alignItems: "center", gap: 10 },
  brandMark: {
    display: "grid", placeItems: "center", width: 38, height: 38, borderRadius: 11,
    background: "rgba(255,255,255,0.14)", border: "1px solid rgba(255,255,255,0.18)",
    fontSize: 18, color: "#fff",
  },
  brand: { fontFamily: "var(--font-display, 'Sora', sans-serif)", fontSize: "24px", fontWeight: 800, letterSpacing: "-0.02em", margin: 0 },
  desc: { color: "#e0e7ff", fontSize: "14px", lineHeight: 1.6, maxWidth: "340px", margin: 0 },
  contactBlock: { display: "flex", flexDirection: "column", gap: "4px", marginTop: "2px" },
  contactLine: { color: "#dbeafe", textDecoration: "none", fontSize: "14px", overflowWrap: "break-word" },
  socialIcons: { display: "flex", gap: "12px", marginTop: "8px" },
  iconLink: {
    display: "grid", placeItems: "center", width: 38, height: 38, borderRadius: 10,
    color: "#e0e7ff", fontSize: "18px", background: "rgba(255,255,255,0.08)",
    border: "1px solid rgba(255,255,255,0.12)", transition: "0.25s",
  },
  linksWrapper: { display: "flex", flex: "2 1 400px", justifyContent: "space-around", gap: "24px" },
  linkSection: { display: "flex", flexDirection: "column", gap: "10px" },
  heading: {
    fontFamily: "var(--font-display, 'Sora', sans-serif)",
    fontSize: "13px", fontWeight: 700, marginBottom: "6px", color: "#fff",
    textTransform: "uppercase", letterSpacing: "1.4px",
  },
  link: { color: "#c7d2fe", textDecoration: "none", fontSize: "14px", transition: "0.25s", width: "fit-content" },
  bottomBar: {
    maxWidth: "1200px", margin: "26px auto 0",
    display: "flex", flexWrap: "wrap", alignItems: "center", justifyContent: "space-between", gap: "8px",
    borderTop: "1px solid rgba(255,255,255,0.14)", paddingTop: "16px",
  },
  copyText: { fontSize: "13px", color: "#cbd5e1", margin: 0 },
  credit: { fontSize: "13px", color: "#cbd5e1", margin: 0 },
};

const hoverStyles = `
  .bytegurukul-footer .footer-link:hover { color: #ffffff !important; transform: translateX(3px); }
  .bytegurukul-footer .footer-icon:hover {
    color: #ffffff !important;
    transform: translateY(-3px);
    background: rgba(255,255,255,0.2) !important;
    border-color: rgba(255,255,255,0.35) !important;
  }

  @media (max-width: 480px) {
    .bytegurukul-footer { padding: 30px 16px 14px !important; }
    .footer-container { flex-direction: column !important; text-align: center !important; align-items: center !important; }
    .brand-section { align-items: center !important; }
    .links-wrapper { flex-direction: column !important; width: 100% !important; gap: 28px !important; }
    .footer-desc { max-width: 100% !important; }
    .social-icons { justify-content: center !important; }
    .bottom-bar { justify-content: center !important; text-align: center !important; }
  }

  @media (min-width: 481px) and (max-width: 768px) {
    .brand-section { flex: 0 0 100% !important; text-align: center !important; align-items: center !important; margin-bottom: 8px !important; }
    .links-wrapper { width: 100% !important; }
  }

  @media (min-width: 1800px) {
    .footer-container, .bottom-bar { max-width: 1600px !important; }
    .footer-brand { font-size: 28px !important; }
    .footer-link, .footer-desc { font-size: 15px !important; }
  }
`;

export default Footer;
